var ConsoleSink = /** @class */ (function () {
    function ConsoleSink() {
    }
    ConsoleSink.prototype.track = function (event, properties) {
        // eslint-disable-next-line no-console
        console.log('[Engage Tracking]', event, properties);
    };
    return ConsoleSink;
}());
export { ConsoleSink };
